import { FullProject } from '../../../projects/types';
import { LoggedUser } from '../../../auth/types';
import { projectStatusConfig } from '../../../projects/configs';
import { invoiceControlConfigByCode } from './status';
import { projectInvoiceStatusConfig } from '../projectInvoice/status';
import { quotationRequestConfigByCode } from '../quotationRequest';
import { isLeader, isOwner } from 'entities/modules/utils';

export function canCancelInvoiceControl(
  { status, invoice, tasks }: FullProject,
  loggedUser: LoggedUser,
) {
  return [
    // 1. project itself is canceled
    status === projectStatusConfig.canceled.code,

    // 2. no outsource
    tasks.every(({ outsourced }) => !outsourced),

    // 3. invoice status allows it
    invoiceControlConfigByCode[invoice.status].canCancel,

    // 4. Not attached
    !invoice.package,

    // 5. if any, all proj invoices should be canceled
    invoice.projectInvoices.every(
      ({ status }) => status === projectInvoiceStatusConfig.canceled.code,
    ),

    // 6. no pending quotation request
    invoice.quotationRequests.every(
      ({ status }) => !quotationRequestConfigByCode[status].requiresUserAction,
    ),

    // 7. Ownership power
    isOwner(invoice, loggedUser) ||
      (isLeader(loggedUser) && loggedUser.team.id === invoice.owner.team),
  ].every(Boolean);
}
